<div class="margin-all-area">
    <div class="wraper-main-section">
        <div class="global-card-section mb-2">
            <div class="global-card-section">
                <div class="inner-header-bg">
                    <div class="inner-cards-panel header-inner-hidden">
                        <span> {{classCodeLabel}} : {{classCodeTitle}}</span>
                    </div>
                </div>
                <div class="inner-header-bg">
                    <div class="inner-cards-panel header-inner-hidden">
                        <span>Code</span>
                        <span>Display</span>
                    </div>
                </div>
                <div class="inner-cards-grid-height">
                    <div class="">
                        <div class="inner-cards-grid" *ngFor="let item of classCodes">
                            <div class="inner-card-mobile">
                                <label>Code</label>
                                <div class="mobile-view-design">
                                    <p>{{item?.id}}</p>
                                </div>
                            </div>
                            <div class="inner-card-mobile">
                                <label>Display</label>
                                <div class="mobile-view-design">
                                    <p>{{item?.text}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
